import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function Tiles(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 12 12">
      <path d="M1 0C0.447715 0 0 0.447715 0 1V4C0 4.55228 0.447715 5 1 5H4C4.55228 5 5 4.55228 5 4V1C5 0.447715 4.55228 0 4 0H1ZM1 7C0.447715 7 0 7.44772 0 8V11C0 11.5523 0.447715 12 1 12H4C4.55228 12 5 11.5523 5 11V8C5 7.44772 4.55228 7 4 7H1ZM7 1C7 0.447715 7.44772 0 8 0H11C11.5523 0 12 0.447715 12 1V4C12 4.55228 11.5523 5 11 5H8C7.44772 5 7 4.55228 7 4V1ZM8 7C7.44772 7 7 7.44772 7 8V11C7 11.5523 7.44772 12 8 12H11C11.5523 12 12 11.5523 12 11V8C12 7.44772 11.5523 7 11 7H8Z"/>
    </CommonSVGIcon>
  );
}
